export const environment = {
  appInsights: {
    instrumentationKey: 'ceb4b89f-cd89-46b0-9f58-7be8cd7bbc62',
  },
  production: false,
  isLocalWeb: false,
  dispatchSelfUpdateTtlMs: 2000,
  isArkikOnline: true,

  /* ======= DUMMY DATA FOR A FAKE USER  ======== */
  apiAccount: 'https://7dc9e933-f5fd-490f-ab84-d75fb9de38db.mock.pstmn.io',
  basicAuthLogin: 's&a=asTU8aST',
  basicAuthPassword: '4w_Vayuc=p5e',

  /* === OLS config ===*/
  OLSDoamin: 'https://api-dev.cemexgo.com',

  ArkikSystemSource: 'D60010',
  /* ======= CONFIGURATION FOR APPLICATION (GIL)  ======== */
  domain: 'http://localhost:4200',
  stripeMode: 'subscription',
  companyCode: '000',
  AppGuid: '09FhaNYg4hjClLWux..BhuDSO...1.0.BhuDSO.IQ4m3V3gskeJqUk_nwx8HX',
  UserGuid:
    'eyJpZCI6IjE0MWUzZjNjLWJkMmQtNTBiZi1iN2Q4LTFlYjUzMzgyNWNjMyIsImNyZWF0ZWQiOjE2Mzk0NjE3ODIxMjcsImV4aXN0aW5nIjpmYWxzZX0=',
  TeamGuid: 'eyJpZCI6IjY2ZjFlMjI3LTA3ZjYtNDEyZS04NTRhLWIyNmIyNWIyY2U5NCIsImNyZWF0ZWQiOjE2Mzk0NjE3ODIzNDd9',
  BusinessPlanGuid: '511=Y-HMR-HXEdRr6LkMxb2j0OahQaj5ZO-D29IazgWIfY2R74Fls8gbXftlm2oJQQMRvDG7N-',
  CompanyGuid: 'HPviM14pgA05rIQ4m3V3gskeJqUk_nwx8HXyLcDwhBvPX0WzTCf5fd-490f',
  ProductGuid: '1Ns2XzD2OizqQCwwaBBdiA1nqjWzr1P4VKbEn0DKQPtJjnU2iYab84-d75fb9de38db',
  EmailSession: 'AHWqTUlqYSAi1OPE1RlK5EFr30rgLETCjGI4O-IIWwhRyz6HXcL5S_112V4I6XWEE9E',
  PasswordSession: 'AJHaeXIVYMC-BQxzKZQ4TEtQClddoNtOmHAp0A6r7qHQD3HLBDeYgfvK_w',
  LoginsSessionStorage: 'xb2j0OahQaj5ZO-D29IazgWIfYqjWzr1P4VKbEn0DKQPtJjnU2iYN2Q4LTFlYjUzMzgyNWNjMyIsImN',
  URLEmailRedirect: 'localhost:4200',
  SupportUserGuid: '87CDB807-FF8C-4A58-8676-FCD948558AAE',
  CompaniesModuleGuid: '49295fe0-a337-461c-b771-28f6e568e59c',

  /* ======= CONFIGURATION FOR GOOGLE'S APIS  ======== */
  GOOGLE_MAPS_KEY: 'AIzaSyDBWyZHIwG_kxjGpFr47iNQhwpKbCRytjA',
  BING_MAPS_KEY:
    'FH8tibuVVZ59Bf7SEPFT~teYAxM3M5N39xoAbYUAMgw~AtaYOlez1CkYuF-TUsuLdXoRC8MwqgcDdBudqdEOVjsPvwboIpUbIyg3jAKxIUGB',

  /* ======= CONFIGURATION FOR B2C ======== */
  B2C_tenantName: 'arkikb2cdev',
  B2C_cemexTenantId: '6ee19001-d0c4-45f8-af8b-ff00f16d07e1',
  B2C_clientId: 'a90a2a65-483a-4327-a460-af164b977064',
  B2C_signInPolicy: 'B2C_1_LoginCleanTest',
  B2C_signInPolicy2: 'B2C_1A_SIGNUP_SIGNIN',
  B2C_redirectUri: 'http://localhost:4200',
  commercialDomain: 'http://localhost:4200',
  B2C_signUpPolicy: 'B2C_1_LoginCleanTest',
  B2C_signup_redirectUri: 'http://localhost:4200/myaccount/',
  B2C_signout:
    'https://arkikb2cdev.b2clogin.com/arkikb2cdev.onmicrosoft.com/b2c_1_logincleantest/oauth2/v2.0/logout?post_logout_redirect_uri=https%3A%2F%2Fscstdarkdb2c.blob.core.windows.net%2Fb2cstatic%2Flogout%2Flogout.html',
  B2C_SSO_invite:
    'https://arkikb2cdev.b2clogin.com/arkikb2cdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_ARKIK_SIGNUP&client_id=a90a2a65-483a-4327-a460-af164b977064&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fuscldarkwad01.azurewebsites.net%2Flogin&scope=openid&response_type=id_token&prompt=login',

  /* ======= CONFIGURATION FOR THE API MANAGMENT ======== */
  APIM: 'https://uscldarkapmd01.azure-api.net/development/api/',
  newOrderAPI: 'arkik-ordertaking/api/',
  apiRecord: 'https://uscldarkapmd01.azure-api.net/development/api/arkik-record',
  apiComPartner: 'https://uscldarkapmd01.azure-api.net/development/api/compartner',
  apiProductSelection: 'https://uscldarkwad03.azurewebsites.net/api/',
  apimSubscriptionKey: '4d4fb6a61e4b4a7f8dacb3027bb59621',
  apiKeySignalR: ')1ntEgr4ti0n5key@f@rk1ktp@mb13ntEde5@rr0/l0(==',

  /* ======= URLS FOR THE APIS ======== */
  apiLogin: 'https://uscldarkwad02.azurewebsites.net',
  apiManagmet: 'https://uscldarkapmd01.azure-api.net/development/api',
  apiNewOrder: 'https://uscldarkwad07.azurewebsites.net/api/',
  apiOrderTaking: 'https://localhost:5149',
  apiDispatcherConsole: 'https://uscldarkapmd01.azure-api.net/development/api/disp',
  apiDispatcherConsoleOnline: 'https://uscldarkapmd01.azure-api.net/development/api/disp',
  apiGlobalAzureFunctions: 'https://uscldarkapmd01.azure-api.net/development/api/inaf/',
  apiMake: 'https://uscldarkapmd01.azure-api.net/development/api/make/',
  apiStock: 'https://uscldarkapmd01.azure-api.net/development/api/stkm/',
  apiSecurityManagment: 'https://uscldarkapmd01.azure-api.net/development/api/secm',
  apiPlanning: 'https://uscldarkapmd01.azure-api.net/development/api/arkik-planning/',
  ProductDetailAPI: 'comproduct/api/productdetail',
  apiBatch: '',
  ApiBatchConfig: '',
  ApiOpenCloudWindow: '',
  apiOverbooking: 'https://uscldarkwapyd01.azurewebsites.net/v1/api/',
  urlsOnline: '',
  urlsAlwaysOnline: '',
  urisExceptions: '',
  urisLocalExceptions: '',
  apiEdgeSettings: 'https://batchcloud:4440/api/EdgeSettings',

  /* ======= COMPONENTS LICENCSE KEYS ======== */
  HandsontableLicenseKey: '8a8cd-83332-73da0-04030-0661f',
  /* ============= DCO =======================*/
  apiDigitalConfirmation: 'https://uscldarkwapyd02.azurewebsites.net/',
  apiKeyDigitalConfirmation: 'PHOrmEkjKj15eXUU3OiPHfdqWBBlkCVp',

  /* ======= URLS WEB SOCKET REMOTE SUPPORT ======== */
  urlWebSocketRemoteSupport: 'wss://uscldarkapmd01.azure-api.net/development/wss/batchremotesupport?',

  /* ======= URLS WEB SOCKET REMOTE SUPPORT ======== */
  remoteSupportSubscriptionKey: '29207e4a462242738d39b08f06eb85cf',

  urlsUnAvailableOffline:
    '/record/customers,/record/services,/analyze/orders-report,/analyze/cash-on-delivery,/analyze/scrap-reuse,/invoice/contracts,/dispatch/trips-report,/make/consumption-report,/make/report-tickets,/analyze/production-quantities,/analyze/recipe-list,/analyze/material-document,/analyze/kpi-dashboard',
  /** ====== Driver Callout Contact Center */
  driverCalloutContactCenter: '+1 (856) 661 4634',

  /* ======= BATCH ON CLOUD ======== */
  componentsOnline: '',
  componentsNonRouteOnline: '',
  urlApimOnline: 'https://uscldarkapmd01.azure-api.net/development/api',

  DynatraceSnippet: '',
  baseHref: '',

  // Logos
  logoSvg: 'assets/images/logo.svg',
  logoDarkSvg: 'assets/images/logo-dark.svg',
  mainLogoSvg: 'assets/images/main_logo.svg',
  mainLogoDarkSvg: 'assets/images/main_logo-dark.svg',
  ArkikMainLogoSvg: 'assets/images/Arkik_main_logo.svg',
  ArkikMainLogoPng: 'assets/images/Arkik_main_logo.png',
  ArkikLogoPng: 'assets/images/Arkik_logo.PNG',
};
